import { Component, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, HostListener } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.css']
})
export class FirmaComponent implements AfterViewInit {
  @ViewChild('signaturePad') signaturePadElement: ElementRef;
  signaturePad: SignaturePad;

  @Output() datosFirma = new EventEmitter<File>();

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.resizeCanvas();
  }

  @HostListener('window:resize')
  onResize() {
    this.resizeCanvas();
  }

  private resizeCanvas() {
    const canvas = this.signaturePadElement.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear(); // Limpia el pad después de redimensionar
  }

  clear() {
    this.signaturePad.clear();
  }

  save() {
    if (this.signaturePad.isEmpty()) {
      alert('Por favor, proporcione una firma primero.');
      return;
    }

    const dataURL = this.signaturePad.toDataURL('image/png');
    const blobBin = atob(dataURL.split(',')[1]);
    const array = [];
    for(let i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i));
    }
    const file = new File([new Uint8Array(array)], 'firma.png', {type: 'image/png'});
    this.datosFirma.emit(file);
  }
}


// WEBPACK FOOTER //
// ./src/app/utilidades/firma/firma.component.ts